import React from "react";
import VLActionModal from "views/uikit/VLModal/VLActionModal";
import SelectList from "views/uikit/FormFields/SelectList";
import { useState } from "react";

interface SelectClassesModalProps {
  isModalOpen: boolean;
  onCLose: () => void;
  options: { label: string; value: string }[];
  selectedValues: string[];
  setSelectedValues: React.Dispatch<React.SetStateAction<string[]>>;
  loading?: boolean;
  onAdd: () => void;
}

export default function SelectClassesModal({
  isModalOpen,
  onCLose,
  options,
  selectedValues,
  setSelectedValues,
  loading,
  onAdd,
}: SelectClassesModalProps) {
  const [selectOpen, setSelectOpen] = useState(false);
  return (
    <VLActionModal
      isOpen={isModalOpen}
      onClose={() => {
        setSelectOpen(false);
        onCLose && onCLose();
      }}
      onClick={onAdd}
      actionLabel={"Add"}
      headers={{
        title: "Add Labels",
        subTitle: "Select at least 2 labels to proceed",
      }}
      variant={"general"}
      direction="row"
      afterOpenChange={(open) => {
        setSelectOpen(open);
      }}
    >
      <SelectList
        options={options}
        placeholder="Select labels"
        value={selectedValues}
        onChange={setSelectedValues}
        loading={loading}
        mode="multiple"
        open={selectOpen}
        onDropdownVisibleChange={(open) => {
          setSelectOpen(open);
        }}
      />
    </VLActionModal>
  );
}
